module.exports = __webpack_public_path__ + "img/组 126@2x(3).02356ed1.png";